import './App.css';

/**
 * Renders a dropdown component with selectable options.
 * 
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.id - The unique identifier for the dropdown.
 * @param {Array} props.currentQuestion - An array of option objects for the dropdown.
 * @param {string} props.value - The currently selected value of the dropdown.
 * @param {function} props.onChange - Callback function to handle changes in the dropdown selection.
 * @param {Object} props.props - Additional props to be spread on the component.
 * @returns {JSX.Element} A dropdown select element with options.
 */
function Dropdown({ id, currentQuestion, value, onChange, props }) {

    // Handle dropdown change event and update state
    const handleChange = (event) => {
      onChange(id, event.target.value);
    };

  return (
    <>
        <select value={value} onChange={handleChange} className='dropdown'>
        {currentQuestion.map((option, index) => (
            <option key={index} value={option.value} disabled={option.disabled}>
            {option.label}
            </option>
        ))}
        </select>
    </>
  );
}

export default Dropdown;